<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-range-picker v-model="transactionDt" :format="getDefaultDateFormat" allowClear />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist :title="isMobile ? 'Alokasi Manager' : 'Rekap Alokasi Pekerjaan Manager'
          " createLink="create.alokasi" manifestLink="manifest.alokasi" :dataList="dataFormatted"
          :manifestActive="false" :clickActive="true" :clickKey="'alokasiListClick'"
          :createDisable="statusEntry ? false : true">
          <template slot="action-button">
            <a-button :disabled="statusEntry ? false : true" icon="plus" type="primary"
              @click="handleCreate">Baru</a-button>

          </template>
        </H-Datalist>
      </a-col>
    </a-row>

    <a-modal :width="750" v-model="modal.visible" title="Rekap Alokasi Baru" @cancel="handleCancel" centered
      :maskClosable="false">
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="Periode" ref="periode" prop="description">
          <a-input v-model="form.periode" disabled />
        </a-form-model-item>
        <a-form-model-item label="Description" ref="description" prop="description">
          <!--          <editor v-model="form.description" />-->
          <div class="example">
            <quill-editor ref="quillEditor" class="editor" :disabled="listClick ? true : false" v-model="form.description"
              :options="editorOption" />
          </div>

        </a-form-model-item>
      </a-form-model>

      <template slot="footer">
        <a-button key="back" :disabled="!!listClick" @click="handleCancel">
          Return
        </a-button>
        <a-button key="submit" :disabled="!!listClick" type="primary" @click="handleSubmit">
          Save
        </a-button>
      </template>



      <!-- <a-form class="m-form" :form="form">
        <a-form-item label="Periode">
          <a-input
            disabled
            v-decorator="['periode', { initialValue: periodeActive }]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            type="textarea"
            v-decorator="[
              'description',
              {
                rules: [
                  { required: true, message: 'Please input your description!' }
                ],
                initialValue: description
              }
            ]"
          />
        </a-form-item>
      </a-form> -->
    </a-modal>
  </a-layout-content>
</template>

<script>
import DataList from "@/components/Datalist";
import { mapGetters } from "vuex";
import moment from "moment";
import { quillEditor } from 'vue-quill-editor'
// highlight.js style
import 'highlight.js/styles/tomorrow.css'
// import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'


export default {
  name: "alokasi-manager",
  components: {
    "H-Datalist": DataList,
    quillEditor,
  },
  data() {
    return {
      transactionDt: [],
      search: "",
      datalist: [],
      statusEntry: false,
      periodeActive: "",
      description: "",
      modal: {
        visible: false,
      },
      form: {
        periode: "",
        description: "",
      },
      rules: {
        periode: [
          {
            required: true,
            message: "Please input your periode!",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Please input your description!",
            trigger: "blur",
          },
        ],
      },
      editorOption: {
        theme: 'snow'
      },
      listClick: false,
      tempPeriodeNow: "",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    this.fetch();
    Event.$on("alokasiListClick", this.handleShow);
  },
  beforeDestroy() {
    Event.$on("alokasiListClick", this.handleShow);
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    dataFormatted() {
      let output = [];

      this.searching.forEach((data) => {
        output.push({
          title: data.no_alokasi,
          subdesc: [
            this.moment(data.awal_periode).format(this.getDefaultDateFormat) +
            " - " +
            this.moment(data.akhir_periode).format(this.getDefaultDateFormat),
            data.departemen + " | " + data.posisi,
            data.site,
          ],
          tempDesc: data.description,
          id: data.id_alokasi,
        });
      });

      return output;
    },
    searching() {
      let output = this.datalist;

      if (this.search) {
        output = this.datalist.filter(
          (obj) =>
            obj.no_alokasi.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.akhir_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.awal_periode.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.departemen.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.posisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.site.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0
        );
      }

      if (this.transactionDt.length > 0) {
        let startDt = moment(this.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        output = this.datalist.filter(
          (obj) => obj.awal_periode >= startDt && obj.akhir_periode <= endDt
        );
      }

      return output;
    },
  },
  methods: {
    moment,
    fetch() {
      this.$store
        .dispatch("getAlokasiManager")
        .then((res) => {
          if (res.list) {
            this.datalist = res.list;
          }
          this.statusEntry = res.status_entry;
        })
        .catch((err) => {
          // console.log(err);
        });
      this.$store.dispatch("getPeriode").then((res) => {
        this.periodeActive = res.periode;
        this.form.periode = res.periode;
        this.tempPeriodeNow = res.periode;
      });
    },
    handleCancel() {
      this.modal.visible = false;
      this.form.description = '';
      this.listClick = false;
      this.form.periode = this.tempPeriodeNow;
    },
    handleCreate() {
      this.modal.visible = true;
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("newAlokasiManager", {
              description: this.$data.form.description,
            })
            .then((res) => {
              this.fetch();
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diubah!",
              });
              this.modal.visible = false;
              this.$data.form.description = "";
            })
            .catch((err) => {
              this.$notification.error({
                message: "Error",
                description: "Please check your data!",
              });
            });
        } else {
          // this.$notification.error({
          //   message: "Error",
          //   description: "Cek Kembali Kelengkapan Form Anda ... !",
          // });
          return false;
        }
      });

      // this.form.validateFields((err, values) => {
      //   if (err) {
      //     this.$notification.error({
      //       message: "Error",
      //       description: "Cek Kembali Kelengkapan Form Anda ... !",
      //     });
      //     return;
      //   }

      // this.$store
      //   .dispatch("newAlokasiManager", {
      //     description: values.description,
      //   })
      //   .then((res) => {
      //     this.fetch();
      //     this.$notification.success({
      //       message: "Sukses",
      //       description: "Data telah berhasil diubah!",
      //     });
      //     this.modal.visible = false;
      //     this.modal.description = "";
      //   })
      //   .catch((err) => {
      //     this.$notification.error({
      //       message: "Error",
      //       description: "Please check your data!",
      //     });
      //   });
      // });
    },
    handleShow(item) {
      this.form.periode = item.subdesc[0];
      this.form.description = item.tempDesc;

      this.modal.visible = true;
      this.listClick = true;
    },
  },
};
</script>

<style lang="less" scoped>
.example {
  display: flex;
  flex-direction: column;

  .editor {
    height: 500px;

  }





}
</style>
